import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  ORDER_KEY, ORDER_TYPE, SORT, STATUS,
} from 'constants/formFields';
import { ORDERS } from 'constants/interfaces';
import { dataMASurveyListSchema } from 'utils/validators/MASurveyValidators';

import type { TDataMASurveyListSchema } from 'utils/validators/MASurveyValidators';

const useMaterialityAssessmentSurveyListForm = () => {
  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    watch,
  } = useForm<TDataMASurveyListSchema>({
    mode: 'onChange',
    resolver: yupResolver(dataMASurveyListSchema),
    defaultValues: {
      [SORT]: {
        [ORDER_KEY]: '',
        [ORDER_TYPE]: ORDERS.asc,
      },
      [STATUS]: '',
    },
  });

  return {
    control,
    handleSubmit,
    getValues,
    setValue,
    watch,
  };
};

export default useMaterialityAssessmentSurveyListForm;
